module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/66bc71cc7b7e48ee3449bc35de71545f.png";